/**
 * created by hezq on 2019-11-21
 *
 * description: 其他工具类
 *
 */

let others = {};

/**
 * description: 为空判断
 * @param {Object} obj 被判断的对象
 * @return {Boolean} true-空 false-非空
 *
 * created by hezq on 2019-11-21
 *
 */
others.isNull = function(obj) {
	// 调用对象的数据类型
	let type = Object.prototype.toString.call(obj);

	// Undefined Null
	if (type === "[object Null]" || type === "[object Undefined]") {
		return true;
	}
	// String
	else if (type === "[object String]" && obj === '') {
		return true;
	}
	// Array
	else if (type === "[object Array]" && obj.length === 0) {
		return true;
	}
	// Object
	else if (type === "[object Object]") {
		for (let key in obj) {
			return false;
		}
		return true;
	}

	return false;
}

/**
 * description: 判断是否为空, 如果为空,用替换对象替换
 * @param {Object} newObj 替换对象
 * @return {Object} 对象
 * 
 * created by hezq on 2019-11-20
 *
 */
others.ifNull = function(obj, newObj) {
	if (others.isNull(obj)) {
		return newObj;
	}
	return obj;
}

/**
 * description: 递归删除Object里值为空的字段
 * @param {Object} obj 被处理的对象
 * @return {Object} 处理后的对象
 *
 * created by hezq on 2019-11-21
 *
 */
others.deleteEmptyProperty = function(obj) {
	for (let key in obj) {
		let value = obj[key];

		if (typeof value === 'object') {
			if (Array.isArray(value)) {
				if (value.length === 0) {
					delete obj[key];
					continue;
				}
			}
			others.deleteEmptyProperty(value);
			if (others.isNull(value)) {
				delete obj[key];
			}
		} else {
			if (!value) {
				delete obj[key];
			}
		}
	}
	return obj;
};

/**
 * description: object深度copy
 * @param {Object} obj 被拷贝对象
 * @return {Object} 拷贝的对象
 *
 * created by hezq on 2019-11-21
 *
 */
others.clone = function(obj) {
	if (!obj || "object" !== typeof obj) {
		return obj;
	}

	if (obj instanceof Date) {
		let copy = new Date();

		copy.setTime(obj.getTime());
		return copy;
	}
	if (obj instanceof Array | obj instanceof Object) {
		let copyTmp = obj instanceof Array ? [] : {};

		for (let attr in obj) {
			if (obj.hasOwnProperty(attr)) {
				copyTmp[attr] = others.clone(obj[attr]);
			}
		}
		return copyTmp;
	}
	throw new Error("Unable to clone obj! Its type isn't supported.");
};

/**
 * description: 清空Object里的属性值，不支持多级object
 * @param {Object} obj 被清空对象
 * @return {Object} 处理后的对象
 *
 * created by hezq on 2019-11-21
 *
 */
others.emptyObj = function(obj) {
	if (!obj || "object" !== typeof obj) {
		return obj;
	}

	if (obj instanceof Date || obj instanceof Array) {
		return obj;
	}
	if (obj instanceof Object) {
		for (let attr in obj) {
			if (obj.hasOwnProperty(attr)) {
				if (typeof obj[attr] === 'string') {
					obj[attr] = "";
				} else if (obj[attr] instanceof Array) {
					obj[attr] = [];
				} else {
					obj[attr] = null;
				}
			}
		}
		return obj;
	}
};

/**
 * description: 获取列表中某个字段的名称
 * @param {Array} arr
 * @param {String} key
 * @param {String | Array} val B00010 [B00010,B00020,B00030]
 * @param {String} labelKey
 * @param {String} sign1 输入值的分隔符 默认逗号
 * @param {String} sign2 输出结果分隔符 默认逗号
 * @return {Sting} NAME1 NAME1,NAME2,NAME3
 * 
 * created by hezq on 2019-11-21
 * 
 */
others.getValueInArray = function(arr, key, val, labelKey, sign1, sign2) {

	if (Array.isArray(arr) && arr.length === 0 || !Array.isArray(arr)) {
		return "";
	} else {
		if (others.isNull(key) || others.isNull(val) || others.isNull(labelKey)) {
			return "";
		}
	}

	sign1 = sign1 || ',';
	sign2 = sign2 || ',';

	let vals = (String (val)).split(sign1);

	let str = '';

	for (let i = 0; i < arr.length; i++) {
		let item = arr[i];

		if (!vals.length) {
			if (String (item[key]) === String (val)) {
				str = item[labelKey] ? item[labelKey] : "";
			}
		} else {
			for (let j = 0; j < vals.length; j++) {
				if (String (item[key]) === String (vals[j])) {
					if (str != '') {
						str += sign2;
					}
					str += item[labelKey] ? item[labelKey] : "";
				}
			}
		}
	}
	return str;
};

/**
 * description: 获取列表中某个字段的中文名称
 * @param {Array} arr
 * @param {String} codekey
 * @param {String} labelKey
 * @param {Number|Array} codeVals 输入值的分隔符  1 [1,2,3]
 * @return {Sting|Array} NAME1 [NAME1,NAME2,NAME3]
 * 
 * created by hezq on 2019-11-21
 * 
 */
others.getValues = function(arr, codekey, labelKey, codeVals) {

	if (Array.isArray(arr) && arr.length === 0 || !Array.isArray(arr) || Array.isArray(codeVals) && codeVals.length === 0) {
		return "";
	} else {
		if (others.isNull(codekey) || others.isNull(labelKey) || others.isNull(codeVals)) {
			return "";
		}
	}

	let res = [];

	for (let i = 0; i < arr.length; i++) {
		let item = arr[i];

		if (!Array.isArray(codeVals)) {
			if (String (item[codekey]) === String (codeVals)) {
				res.push(item[labelKey] ? item[labelKey] : "");
			}
		} else {
			for (let j = 0; j < codeVals.length; j++) {
				if (String (item[codekey]) === String (codeVals[j])) {
					res.push(item[labelKey] ? item[labelKey] : "");
				}
			}
		}
	}

	if (Array.isArray(codeVals)) {
		return res;
	} else {
		return res[0];
	}

};

/**
 * description: 获取列表中所有对象的某个值，用符号连接返回
 * @param {Array} arr
 * @param {String} key
 * @param {String} sign
 * @return {Sting} NAME1,NAME2,NAME3
 * 
 * created by hezq on 2019-11-21
 * 
 */
others.getContent = function(arr, key, sign) {
	if (!arr || arr.length === 0 || !key) {
		return "";
	}

	let temp = [];

	for (let i = 0; i < arr.length; i++) {
		temp.push(arr[i][key]);
	}
	if (!sign) {
		sign = ',';
	}
	return temp.join(sign);
};

/**
 * description: 滚动条从某个位置滚到某个位置
 * @param {Element} el 滚动条对象
 * @param {Number} from 滚动条开始位置
 * @param {Number} to 滚动条到结束位置
 * @param {Number} duration 滚动完成的时间
 * @param {function} endCallback 滚动之后回调事件
 * 
 * created by hezq on 2019-11-21
 * 
 */
others.scrollTop = function(el, from = 0, to, duration = 500, endCallback) {
	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame =
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}
	const difference = Math.abs(from - to);
	const steps = Math.ceil(difference / duration * 50);

	function scroll(start, end, step) {
		if (start === end) {
			endCallback && endCallback();
			return;
		}

		let d = start + step > end ? end : start + step;

		if (start > end) {
			d = start - step < end ? end : start - step;
		}

		if (el === window) {
			window.scrollTo(d, d);
		} else {
			el.scrollTop = d;
		}
		window.requestAnimationFrame(() => scroll(d, end, step));
	}
	scroll(from, to, steps);
};

/**
 * description: 获取当前url的所有query参数
 * @return {Object} key-value存储
 * 
 * created by hezq on 2019-11-21
 * 
 */
others.getQueryParam = function() {
	// 获取url中"?"符后的字串  
	let url = location.search;
	let params = {};

	if (url.indexOf('?') !== -1) {
		let str = url.substr(1);
		let strs = str.split('&');

		for (let i = 0; i < strs.length; i++) {
			params[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
		}
	}
	return params;
};

export default others;



// WEBPACK FOOTER //
// ./src/tools/other/index.js